import { jsx as _jsx } from "react/jsx-runtime";
import { StyledHr } from './styles';
import { HrWeight } from './types';
const weightToHeight = {
    [HrWeight.Normal]: 1,
    [HrWeight.Heavy]: 2,
};
const Hr = ({ weight = HrWeight.Normal, color = 'black', opacity = 1, className }) => {
    return (_jsx(StyledHr, { "$height": weightToHeight[weight], "$color": color, "$opacity": opacity, className: className }));
};
export default Hr;
//# sourceMappingURL=index.js.map